import { useTranslation } from "react-i18next";
import { Ban, CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Avatar } from "@/components/admin/Avatar";

const COUNTRY_LABELS = { martinique: "Martinique", guadeloupe: "Guadeloupe", "saint-martin": "Saint-Martin", "sint-maarten": "Sint Maarten" };

export function LoueursTable({ loueurs, v2, isSuper, onToggle, onSetPlan }) {
  const { t } = useTranslation();
  return (
    <div className="bg-white rounded-2xl shadow-card border border-border overflow-x-auto">
      <table className="w-full text-sm">
        <thead className="bg-sand"><tr className="text-left text-muted2 font-bold text-xs uppercase"><th className="p-3">{t("dash.company")}</th><th className="p-3 hidden sm:table-cell">{t("dash.destination")}</th><th className="p-3">{t("dash.vehicles")}</th><th className="p-3">{t("dash.kyc")}</th>{v2 && <th className="p-3">{t("plans.tab")}</th>}<th className="p-3">{t("dash.action")}</th></tr></thead>
        <tbody>
          {loueurs.map((l) => (
            <tr key={l.id} data-testid={`admin-loueur-${l.id}`} className="border-t border-border font-body">
              <td className="p-3"><div className="flex items-center gap-2.5"><Avatar url={l.avatar_url} name={l.company_name || l.name} testid={`admin-loueur-avatar-${l.id}`} /><div><p className="font-semibold text-ink">{l.company_name || l.name}</p><p className="text-xs text-muted2">{l.email}</p></div></div></td>
              <td className="p-3 hidden sm:table-cell text-muted2">{COUNTRY_LABELS[l.country] || "—"}</td>
              <td className="p-3 font-bold">{l.vehicles_count}</td>
              <td className="p-3"><span className={`text-xs font-bold px-2 py-0.5 rounded-full ${l.kyc_status === "verified" ? "bg-emeraude/15 text-emeraude-dark" : "bg-yellow-100 text-yellow-700"}`}>{l.kyc_status === "verified" ? t("dash.verified") : t("dash.pending")}</span></td>
              <td className="p-3">
                {!v2 ? <span className="text-xs text-muted2">—</span> : isSuper ? (
                  <select data-testid={`plan-select-${l.id}`} value={l.plan || "free"} onChange={(e) => onSetPlan(l.id, e.target.value)} className="rounded-full border border-border bg-white text-xs font-bold px-2 py-1 text-ink">
                    <option value="free">Découverte</option>
                    <option value="essentiel">Cap Essentiel</option>
                    <option value="croissance">Cap Croissance</option>
                    <option value="premium">Cap Premium</option>
                  </select>
                ) : (<span className="text-xs font-bold text-ink">{l.plan || "free"}</span>)}
              </td>
              <td className="p-3">
                <Button size="sm" variant="outline" data-testid={`toggle-loueur-${l.id}`} onClick={() => onToggle(l)} className={`rounded-full h-8 ${(l.active ?? true) ? "text-destructive border-destructive/30" : "text-emeraude-dark"}`}>
                  {(l.active ?? true) ? <><Ban className="w-3.5 h-3.5 mr-1" /> {t("dash.suspend")}</> : <><CheckCircle2 className="w-3.5 h-3.5 mr-1" /> {t("dash.activate")}</>}
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
